import axios from "axios";
import { functionType } from "../../types";

export function callLoginApi(email: string, password: string) {
  return axios({
    method: "POST",
    url: "/api/Security/authenticate",
    headers: {
      "Content-Type": "application/json"
    },
    data: {
      Username: email,
      password: password
    }
  });
}

export function generateEmailApi(
  recoveryEmail: string,
  callback: functionType
) {
  axios({
    method: "POST",
    url: "/api/Security/generate-reset-password-token",
    headers: {
      "Content-Type": "application/json"
    },
    data: JSON.stringify(recoveryEmail)
  })
    .then(function(response) {
      callback(response.data);
    })
    .catch(err => {
      console.warn(err);
    });
}

export function resetPasswordApi(newPassword: string, jwt: string) {
  return axios({
    method: "POST",
    url: "/api/Security/reset-password",
    headers: {
      "Content-Type": "application/json"
    },
    data: JSON.stringify({
      newPassword: newPassword,
      jwt: jwt
    })
  });
}

resetPasswordAccountManagement;
export function resetPasswordAccountManagement(newPassword: string, jwt:string, userId: number) {
  return axios({
    method: "POST",
    url: "/api/Users/reset-password-account-management",
    headers: {
      "Content-Type": "application/json"
    },
    data: JSON.stringify({
      userId: userId,
      newPassword: newPassword
    })
  });
}
